import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import ProtectedAdminRoute from "@/components/ProtectedAdminRoute";
import ProtectedRestaurantRoute from "@/components/ProtectedRestaurantRoute";
import ProtectedRiderRoute from "@/components/ProtectedRiderRoute";
import Home from "@/pages/Home";
import Restaurants from "@/pages/Restaurants";
import RestaurantDetail from "@/pages/RestaurantDetail";
import Categories from "@/pages/Categories";
import FamilyDeals from "@/pages/FamilyDeals";
import Checkout from "@/pages/Checkout";
import OrderConfirmation from "@/pages/OrderConfirmation";
import OrderTracking from "@/pages/OrderTracking";
import HowItWorks from "@/pages/HowItWorks";
import Partner from "@/pages/Partner";
import Help from "@/pages/Help";
import { Terms, Privacy } from "@/pages/Legal";
import Admin from "@/pages/Admin";
import AdminLogin from "@/pages/AdminLogin";
import RestaurantAdmin from "@/pages/RestaurantAdmin";
import RestaurantAdminLogin from "@/pages/RestaurantAdminLogin";
import Rider from "@/pages/Rider";
import RiderLogin from "@/pages/RiderLogin";
import QRLanding from "@/pages/QRLanding";
import RiderAccept from "@/pages/RiderAccept";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <CartProvider>
              <Routes>
                <Route path="/welcome" element={<QRLanding />} />
                <Route path="/rider/accept/:orderNumber" element={<RiderAccept />} />
                <Route path="/" element={<Layout />}>
                  <Route index element={<Home />} />
                  <Route path="restaurants" element={<Restaurants />} />
                  <Route path="restaurant/:id" element={<RestaurantDetail />} />
                  <Route path="categories" element={<Categories />} />
                  <Route path="family-deals" element={<FamilyDeals />} />
                  <Route path="checkout" element={<Checkout />} />
                  <Route path="order-confirmation/:orderNumber" element={<OrderConfirmation />} />
                  <Route path="order-tracking/:orderNumber" element={<OrderTracking />} />
                  <Route path="how-it-works" element={<HowItWorks />} />
                  <Route path="partner" element={<Partner />} />
                  <Route path="help" element={<Help />} />
                  <Route path="terms" element={<Terms />} />
                  <Route path="privacy" element={<Privacy />} />
                  <Route path="admin/login" element={<AdminLogin />} />
                  <Route path="admin" element={<ProtectedAdminRoute><Admin /></ProtectedAdminRoute>} />
                  <Route path="restaurant-admin/login" element={<RestaurantAdminLogin />} />
                  <Route path="restaurant-admin" element={<ProtectedRestaurantRoute><RestaurantAdmin /></ProtectedRestaurantRoute>} />
                  <Route path="rider/login" element={<RiderLogin />} />
                  <Route path="rider" element={<ProtectedRiderRoute><Rider /></ProtectedRiderRoute>} />
                  <Route path="rider/:orderNumber" element={<ProtectedRiderRoute><Rider /></ProtectedRiderRoute>} />
                </Route>
              </Routes>
            </CartProvider>
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
